import {BrowserModule} from '@angular/platform-browser';
import {DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MainComponent} from './views/main/main.component';
import {HeaderComponent} from './views/header/header.component';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {SidebarComponent} from './views/sidebar/sidebar.component';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxSpinnerModule} from 'ngx-spinner';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {registerLocaleData} from '@angular/common';
import localePt from '@angular/common/locales/pt';
import {LogoutComponent} from './views/logout/logout.component';
import {AppDataService} from './service/app_data.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxPaginationModule} from 'ngx-pagination';
import {HomeComponent} from './views/home/home.component';
import {NotificationComponent} from './views/notification/notification.component';
import {NgApexchartsModule} from 'ng-apexcharts';
import {RegisterDetailComponent} from './views/register-detail/register-detail.component';
import {UserComponent} from './views/user/user.component';
import {AuthenticateComponent} from './views/authenticate/authenticate.component';
import {HeaderHttpInterceptor} from './base/header-interceptor';
import {GraphQLModule} from './graphql.module';
import {CURRENCY_MASK_CONFIG} from 'ng2-currency-mask';
import {BannerComponent} from './views/banner/banner.component';
import {CropImageComponent} from './views/crop-image/crop-image.component';
import {ImageCropperModule} from 'ngx-image-cropper';
import {ContactComponent} from './views/contact/contact.component';
import {ContentComponent} from './views/content/content.component';
import {GriComponent} from './views/gri/gri.component';
import {DashboardComponent} from './views/dashboard/dashboard.component';
import {LongTermGoalsComponent} from './views/long-term-goals/long-term-goals.component';
import {GriDetailComponent} from './views/gri/gri-detail/gri-detail.component';
import {HighlightsComponent} from './views/highlights/highlights.component';
import {BannerDetailComponent} from './views/banner/banner-detail/banner-detail.component';
import {ContentDetailComponent} from './views/content/content-detail/content-detail.component';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {ColorPickerModule} from 'ngx-color-picker';
import {CardProfileComponent} from './views/components/card-profile/card-profile.component';
import {DatePickerCustomModule} from './views/components/date-picker-custom/date-picker-custom.module';
import {OnlyNumberDirective} from './directive/only-number.directive';
import {LongTermGoalsDetailComponent} from "./views/long-term-goals/long-term-goals-detail/long-term-goals-detail.component";
import {ThemesComponent} from './views/themes/themes.component';

registerLocaleData(localePt, 'pt-BR');

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        MainComponent,
        HeaderComponent,
        SidebarComponent,
        LogoutComponent,
        HomeComponent,
        NotificationComponent,
        RegisterDetailComponent,
        UserComponent,
        AuthenticateComponent,
        BannerComponent,
        BannerDetailComponent,
        CropImageComponent,
        ContactComponent,
        ContentComponent,
        GriComponent,
        DashboardComponent,
        LongTermGoalsComponent,
        GriDetailComponent,
        HighlightsComponent,
        CardProfileComponent,
        OnlyNumberDirective,
        ContentDetailComponent,
        LongTermGoalsDetailComponent,
        ThemesComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        HttpClientModule,
        AngularSvgIconModule.forRoot(),
        SlickCarouselModule,
        FormsModule,
        NgxSpinnerModule,
        ImageCropperModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgApexchartsModule,
        NgxPaginationModule,
        GraphQLModule,
        CKEditorModule,
        ColorPickerModule,
        DatePickerCustomModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HeaderHttpInterceptor,
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'pt-BR'
        },
        {
            provide: DEFAULT_CURRENCY_CODE,
            useValue: 'BRL'
        },
        {
            provide: CURRENCY_MASK_CONFIG,
            useValue: {   // BRL
                align: 'left',
                allowNegative: true,
                decimal: ',',
                precision: 2,
                prefix: 'R$ ',
                suffix: '',
                thousands: '.'
            }
        },
        TranslateService,
        AppDataService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
